 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLHALFTITLE from '@/components/xhtml/Halftitle'
 import XHTMLSERIES from '@/components/xhtml/Series'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLACK from '@/components/xhtml/Ack'
 import XHTMLHALFTITLE2 from '@/components/xhtml/Halftitle2'
 import XHTML01_ILANY_INTRO from '@/components/xhtml/01_Ilany_Intro'
 import XHTML02_ILANY_CH01 from '@/components/xhtml/02_Ilany_Ch01'
 import XHTML03_ILANY_CH02 from '@/components/xhtml/03_Ilany_Ch02'
 import XHTML04_ILANY_CH03 from '@/components/xhtml/04_Ilany_Ch03'
 import XHTML05_ILANY_CH04 from '@/components/xhtml/05_Ilany_Ch04'
 import XHTML06_ILANY_CH05 from '@/components/xhtml/06_Ilany_Ch05'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML07_ILANY_CONCLUSION from '@/components/xhtml/07_Ilany_Conclusion'
 import XHTML08_ILANY_BIBLIOGRAPHY from '@/components/xhtml/08_Ilany_Bibliography'
 import XHTMLILANY_INDEX from '@/components/xhtml/Ilany_Index'
 import XHTML09_ILANY_BIO from '@/components/xhtml/09_Ilany_Bio'
 import XHTMLBACK_COVER from '@/components/xhtml/Back_Cover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Ack",
 			"name" : "xhtml/Ack",
 			"component" : XHTMLACK
 		},
 		{
 			"path" : "/xhtml/Halftitle2",
 			"name" : "xhtml/Halftitle2",
 			"component" : XHTMLHALFTITLE2
 		},
 		{
 			"path" : "/xhtml/01_Ilany_Intro",
 			"name" : "xhtml/01_Ilany_Intro",
 			"component" : XHTML01_ILANY_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js